;(function () {
  'use strict'
  angular
    .module('contrast.freemium')
    .factory(
      'freemiumApiConfig',
      function freemiumApiConfigFactory($http, UserService) {
        'ngInject'

        return {
          getPreference: getPreference
        }

        function getPreference(name) {
          return $http.get(
            UserService.buildAPIUrl('/freemium/settings/' + name)
          )
        }
      }
    )
})()
